import React from "react"
import { PeriodSelector } from "@/components/forms/PeriodSelector"
import { SettingsLayout } from "@/components/layouts/setting-layout/SettingsLayout"
import { useForm } from "react-hook-form"
import { PeriodFormData, PeriodFormDataOptionalRange } from "@/state/draft/period"
import { RHFProvider } from "@/components/forms/RHFProvider"
import { useFormAutoSave } from "@/hooks/useFormAutoSave"

type EditPeriodScreenProps = {
	onSave: (data: PeriodFormData) => void
	onSaveLocal: (data: PeriodFormData) => void
	value: PeriodFormData
	reportId: string
	savingInProcess: boolean
}

type FormData = PeriodFormDataOptionalRange

export const EditPeriodScreen: React.FC<EditPeriodScreenProps> = (props) => {
	const form = useForm<FormData>({
		defaultValues: props.value,
	})
	useFormAutoSave(
		form.control,
		(data) => {
			if (data.range[0] && data.range[1]) {
				props.onSaveLocal(data as PeriodFormData)
			}
		},
		props.value as FormData
	)
	return (
		<SettingsLayout
			savingInProcess={props.savingInProcess}
			reportId={props.reportId}
			title="Report Period"
			activeSection="reporting-period"
			onSave={() => {
				form.handleSubmit((data) => {
					// TODO: fixed when form validation is fixed
					props.onSave(data as PeriodFormData)
				})()
			}}
		>
			<RHFProvider form={form}>
				<PeriodSelector form={form} />
			</RHFProvider>
		</SettingsLayout>
	)
}
